import { SubscriptionDTO } from "@campgladiator/cg-common.types.types";

export const subscription: SubscriptionDTO = {
  id: "21a2264a-721a-4ec3-a863-a2c257386527",
  userId: "46c6ec0f-9b89-4588-9df9-0269ddaeccda",
  stripeCustomerId: "cus_NpTHR8UwnqJewS",
  stripeSubscriptionId: "sub_1N9TvkJWDZbdRfZoU1FzEZw9",
  periodEndDate: "2023-09-03T00:00:00Z",
  purchaseDate: "2023-05-19T14:05:15.9242Z",
  productId: "prod_NWJLE0Sg2E1ejR",
  productName: "Outdoor & Online Camp: 24 Months Membership",
  productType: "BOOTCAMP",
  productSubType: "IN_PERSON",
  termLength: 24,
  purchasePrice: 5900,
  productPrice: 5900,
  salesRep: "53148c23-7ae0-4493-b53d-0d180141fae5",
  servicingTrainer: "53148c23-7ae0-4493-b53d-0d180141fae5",
  couponCode: null,
  promoCode: null,
  status: "CANCELED",
  programId: null,
  programScheduleId: null,
  periodStartDate: "2023-03-03T00:00:00Z",
  billingDate: "2023-06-03T00:00:00Z",
  resumesAt: null,
  archivedAt: "2023-08-17T14:56:00.605871Z",
  trialPeriodDays: null,
  paymentProcessorProvider: "STRIPE",
  upgradedFrom: null,
  contractStatistics: {
    paymentCount: 2,
    inContract: false,
    paymentsRemaining: 22,
    priceSelection: "RECOMMIT_PRICE",
  },
  lastUpdatedBy: null,
  createdBy: "",
  recommit: false,
  cancellationReason: null,
  acceptedTermsAndConditions: null,
};
